import React, { useContext, useEffect } from 'react';
import { Router } from '@reach/router';
import { GlobalContext } from 'commons';
import { contactIdPrivate, orgId } from 'utils';
import cssVars from 'css-vars-ponyfill';
import v from 'scss/v';
import Home from './Home';
import getRoutes from './routes';
import NotFoundPage from './NotFoundPage';
import CommsDetail from '../commsDetail';
import {cookies} from "../../utils";

const App = () => {
  const {
    lang,
    organization: {
      enableReceiptTranscripts,
      orgName,
      orgDisable,
    },
    account: {
      id: accountId,
    },
    navConfig: {
      showSignUp,
      showCrisisTask,
      showCrisisSingleEventDashboard,
      showNotification,
      showWeather,
      showEvent,
      showIncidents,
      enabledSSO,
      showDirectoryChat,
      fromMemberApp,
      accessKey,
    },
    googleMapParam,
  } = useContext(GlobalContext);

  useEffect(() => {
    // init css var variable
    cssVars({
      onlyLegacy: true,
      watch: true,
      shadowDOM: true,
      // do not replace these plugin's css
      exclude: '[href*=fontawesome]',
    });
  }, []);



  // Override native onfocus listener
  const oldAddListener = HTMLElement.prototype.addEventListener;
  const customFunction = function (orginalBehavior, customStyle) {
    return function (e) {
      // put getComputedStyle inside to reduce calling frequency
      const cssDetector = window.getComputedStyle(document.getElementById('css-detector'), null);
      if (cssDetector.visibility !== 'hidden' && e.target.tabIndex !== -1) {
        // clear inline style when lose focus
        e.target.style = customStyle;
      }
      orginalBehavior(e);
    };
  };

  if (typeof EventTarget !== 'undefined') {
    EventTarget.prototype.addEventListener = function () {
      const scope = this;
      const orginalBehavior = arguments[1];

      if (arguments[0] === 'blur') {
        arguments[1] = customFunction(orginalBehavior, '');
      }

      if (arguments[0] === 'focus') {
        arguments[1] = customFunction(orginalBehavior,
          `outline-offset: 2px;
              outline: 3px solid ${v('$control-pacific')};`);
      }

      oldAddListener.apply(this, arguments);
    };
  }

  const routes = (orgDisable) ? [] : getRoutes({
    enableReceiptTranscripts,
    orgId,
    contactIdPrivate,
    orgName,
    showSignUp,
    showCrisisTask,
    showCrisisSingleEventDashboard,
    showNotification,
    showWeather,
    showEvent,
    showIncidents,
    enabledSSO,
    showDirectoryChat,
    accountId,
    fromMemberApp,
    accessKey
  });

  if (!orgName) {
    return null;
  }

  if (/^\/\d+\/(portal-home|new-profile)(\/.*)*$/.test(window.location.pathname)) {
    cookies.set('entryFromPublicPortal', 'true', {
      path: `/${orgId}`
    });
  }
  if (/^\/\d+\/(new$|login)(\/.*)*$/.test(window.location.pathname)) {
    cookies.remove('entryFromPublicPortal', {
      path: `/${orgId}`
    })
  }

  return (
    <>
      <Router primary={false}>
        <Home path="/:orgId">
          {routes.map(router => {
            if (!router.subRoutes) {
              return (
                <router.component
                  {...{
                    ...router.props,
                    lang,
                    accountId,
                    orgName,
                    googleMapParam,
                  }}
                />
              );
            }

            return (
              <router.component
                {...{
                  ...router.props,
                  lang,
                  accountId,
                  orgId,
                  orgName,
                  googleMapParam,
                }}
              >
                {router.subRoutes.map(child => (
                  <child.component
                    {...{
                      ...child.props,
                      lang,
                      accountId,
                      orgName,
                      googleMapParam,
                    }}
                  />
                ))}
              </router.component>
            );
          })}
          <NotFoundPage default />
        </Home>
        <Home path="comms">
          <CommsDetail path="/:commsId" />
        </Home>
      </Router>
      <span id="css-detector" />
    </>
  );
};

export default App;
